export function GlobalLoaderLogo({ size = "md", className = "" }) {
    const config = {
        sm: { icon: 36, fontSize: 18, gap: 8 },
        md: { icon: 52, fontSize: 26, gap: 12 },
        lg: { icon: 72, fontSize: 36, gap: 16 },
    }[size];

    return (
        <div
            className={className}
            style={{
                display: "inline-flex",
                alignItems: "center",
                gap: config.gap,
                userSelect: "none",
                marginBottom: "10px"
            }}
        >
            {/* ── Icon box ── */}
            <div
                style={{
                    width: config.icon,
                    height: config.icon,
                    borderRadius: config.icon * 0.22,

                    background: "#8f8dfc",
                    boxShadow: "0px 0px 15px 0px #8F8CFF80",


                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    position: "relative",
                    overflow: "hidden",
                }}
            >
                {/* Subtle inner glow */}
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        // background: "radial-gradient(circle at 35% 35%, rgba(255,255,255,0.18) 0%, transparent 65%)",
                        borderRadius: "inherit",
                    }}
                />
                <img
                    src="/logo_campus_last.svg"
                    alt="CampusMesh icon"
                    width={config.icon * 0.72}
                    height={config.icon * 0.72}
                    style={{ position: "relative", zIndex: 1 }}
                />
            </div>


        </div>
    );
}